import { ClaudeTemplate } from "../types";

/** YouTube comprado desde DV360: line items "YouTube & partners" con ad groups. */
export const dv360YouTubeTemplate: ClaudeTemplate = {
  id: "dv360-youtube",
  tool: "Display & Video 360 (DV360) — YouTube & partners",
  url: "https://displayvideo.google.com/",
  hierarchy:
    "Partner → Advertiser → Campaign → Insertion Order (IO) → Line Item YouTube & partners → Ad groups → Ads (vídeos de YouTube)",
  idHint:
    "columna ID de la tabla o número que aparece en la URL al abrir el IO (…/io/<ID>/…)",
  accountField: "dv360AdvertiserIds",
  steps: `
### 1. Entrar en el advertiser (puede que ya estés dentro)
1. Abre DV360 ({{url}}). Si ya está abierto, sigue.
2. Entra en el **Partner** de la agencia. Si ya estás dentro, sigue.
3. Entra en el **Advertiser** del cliente {{client}}. ID(s) conocidos: {{accountIds}}. Si no hay ID, búscalo por nombre; si hay varios candidatos, pregunta.

### 2. Campaign
1. Busca la campaign **{{names.campaign}}**. Si existe, entra y salta al paso 3.
2. Si no existe, créala con Name {{names.campaign}}, fechas {{goal.startDate}} → {{goal.endDate}}, goal "Raise awareness of my brand or product" (o el que encaje con {{goal.kpi}}) y creative type Video.

### 3. Insertion Order
1. Busca el IO **{{names.order}}**. Si existe, no lo dupliques: entra y salta al paso 4.
2. Si no existe, créalo:
   - Name: {{names.order}}
   - Budget: {{goal.budget}}, segmento {{goal.startDate}} → {{goal.endDate}}, pacing "Flight" / "Even".
   - KPI: {{goal.kpi}} = {{goal.netUnitCost}}.
   - Estado: **Draft**.

### 4. Line Item YouTube
1. En el IO, crea un line item de tipo **"YouTube & partners"**.
2. El subtipo depende del tipo de campaña {{campaignType}}:
   - SKIPPABLE → "Skippable in-stream" / "Efficient reach" con anuncios saltables, puja Target CPM o CPV.
   - NON_SKIPPABLE → "Non-skippable" (vídeos de 15 s o menos), Target CPM.
   - BUMPER → "Bumper" (6 s), Target CPM.
   - SHORTS → inventario de Shorts (vídeo vertical).
   - SEQUENCE → "Ad sequence"; el orden de los vídeos debería venir en las notas; si no viene, pregunta.
   - MASTHEAD y PAUSEAD → suelen ser compras reservadas a través de Google. Si no ves la opción en DV360, para y avísame.
   - CONNECTEDTV → YouTube solo en TV conectadas (en Devices deja solo "Connected TV").
   Si el subtipo no aparece con ese nombre, elige el más parecido y dímelo.
3. Configúralo:
   - Name: {{names.line}}
   - Flight: {{goal.startDate}} → {{goal.endDate}}.
   - Budget: hasta el presupuesto del IO ({{goal.budget}}).
   - Bid strategy: CPM o CPV objetivo en torno a {{goal.netUnitCost}}.
4. Targeting:
   - Geography: {{target.geography}} (país {{goal.country}}). Language: {{target.language}}.
   - Demographics: {{target.gender}}, {{target.age}}.
   - Audiences: {{target.audience}}. Intereses / afinidades: {{target.interests}}.
   - Devices: {{target.technology}}.
   - Exclusiones: {{target.exclusions}}.
5. Deja el line item en **Draft**.

### 5. Ad groups y anuncios
1. Crea el ad group (si el asistente no lo creó ya) con el nombre {{names.line}}.
2. Los anuncios de YouTube usan vídeos ya subidos a YouTube: busca en el bloque "Creatividades" las URLs de YouTube. Si en lugar de URLs de YouTube hay archivos, para y avísame (hay que subirlos a un canal antes).
3. Para cada anuncio: URL del vídeo, URL final de destino (bloque "URLs de destino", con UTM), display URL y, si el formato lo pide, call-to-action y headline (bloque "Copies").
4. Guarda todo sin activar.
`,
};
